import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-toolbar',
  templateUrl: './editor-toolbar.component.html',
  styleUrls: ['./editor-toolbar.component.scss'],
})
export class EditorToolbarComponent {
  @Input() toolbar: string[] = [
    'SIZE',
    'TEXT_DECORATION',
    'INSERT',
    'LIST',
    'ALIGNMENT',
  ];

  isShowButton(action: string) {
    return this.toolbar.includes(action);
  }
}
